/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Save_SuccessInputs */



/**
* | output |
* | --- |
* | "Recording saved successfully!" |
*
* @param {Audio_Recorder_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_save_success = /** @type {((inputs?: Audio_Recorder_Save_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Save_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement sauvegardé avec succès !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme erfolgreich gespeichert!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione salvata con successo!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись успешно сохранена!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Grabación guardada exitosamente!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制保存成功！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録音が正常に保存されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग सफलतापूर्वक सहेज ली गई!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gravação salva com sucesso!")
	return /** @type {LocalizedString} */ ("Recording saved successfully!")
});